module.exports = __webpack_public_path__ + "static/img/son1_active.1fe70140.png";